import React, { useState } from 'react';
import { FiSend, FiAlertCircle } from 'react-icons/fi';
import './Promotions.css';
import apiClient from '../apis/apiClient';

const Promotions = () => {
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Check for empty fields
    if (!subject.trim() || !content.trim()) {
      setError('Please fill in all fields');
      return;
    }

    // ✅ Get the token from localStorage
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('You must be logged in to send promotions.');
      return;
    }

    setIsSending(true);
    setError('');

    try {
      await apiClient.post('/promotions/send', { subject, content });

      setIsSent(true);  // Indicate that promotion has been sent
      setSubject('');  // Reset subject field
      setContent('');  // Reset content field
      setTimeout(() => setIsSent(false), 3000);  // Hide success message after 3 seconds
    } catch (err) {
      console.error('Promotion send error:', err);
      setError(err.response?.data?.message || 'Failed to send promotions. Please try again.');
    } finally {
      setIsSending(false);  // Reset the sending state
    }
  };

  return (
    <div className="promotions-page">
      <h1 className="promo-title">📢 Promotion Campaign</h1>
      <p className="promo-subtitle">Send professional promotional emails to all registered users.</p>

      <div className="promo-card">
        <form onSubmit={handleSubmit} className="promo-form">
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              placeholder="Special Offer: Flat 20% Discount!"
            />
          </div>

          <div className="form-group">
            <label htmlFor="content">Email Content</label>
            <textarea
              id="content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
              rows={8}
              placeholder="Write your promotional message here..."
            />
          </div>

          {/* Show error message */}
          {error && (
            <div className="error-message">
              <FiAlertCircle className="error-icon" />
              {error}
            </div>
          )}

          {/* Show success message */}
          {isSent && (
            <div className="success-message">
              ✅ Promotion sent successfully to all users!
            </div>
          )}

          {/* Submit button */}
          <button
            type="submit"
            className="send-button"
            disabled={isSending || !subject.trim() || !content.trim()}
          >
            {isSending ? (
              <span>Sending...</span>
            ) : (
              <>
                <FiSend className="button-icon" />
                <span>Send Promotion</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Promotions;
